import { ArrowRight, ChevronLeft, X } from "lucide-react";
import { Button } from "@components/ui/button";
import { useNavigate } from "react-router";
import { Input } from "@components/ui/input";
import ColumnChart from "@components/chart";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { saveFiltersState, updateCompanySize } from "@redux/slices/filter";
import { useEffect, useState } from "react";
import { Checkbox } from "@mui/material";
// import { Checkbox } from "@components/ui/checkbox";

interface Props {
  handleClose: () => void;
}

const CompanySize: React.FC<Props> = ({ handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const companySize = useSelector(
    (state: RootState) => state.filter.companyFilters.companySize
  );

  const data=useSelector((state: RootState)=>state.filter);

  const [from, setFrom] = useState(companySize.from);
  const [to, setTo] = useState(companySize.to);
  const [size, setSize] = useState(companySize.unknownSize);

  useEffect(() => {
    setFrom(companySize.from);
    setTo(companySize.to);
    setSize(companySize.unknownSize);
    console.log(companySize);
    console.log(data)
    console.log("I am here here hereh eere")
  }, [companySize]);

  const handleFromChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10) || 0;
    setFrom(value);
    dispatch(updateCompanySize({ from: value, to, unknownSize: size }));
  };

  const handleToChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10) || 0;
    setTo(value);
    dispatch(updateCompanySize({ from, to: value, unknownSize: size }));
  };

  const handleCheckboxChange = () => {
    const updatedSize = !size;
    setSize(updatedSize);
    dispatch(updateCompanySize({ from, to, unknownSize: updatedSize }));
  };

  return (
    <div className="flex flex-col justify-between h-full p-8">
      <div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Company Size
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>
        <div className="flex gap-4">
          {/* <div className="bg-white w-7/12 rounded-lg px-6 py-4">
            <h4 className="text-lg font-bold flex items-center mb-4">
              Employee Distribution
            </h4>
            <ColumnChart />
          </div> */}
          <div className="bg-white w-6/12 rounded-lg px-6 py-4">
            <h4 className="text-lg font-bold flex items-center mb-4">
              No of Employees
            </h4>
            <p className="text-[#71717A] mb-1">From</p>
            <Input
              type="number"
              value={from}
              onChange={handleFromChange}
              placeholder="0"
            />
            <p className="text-[#71717A] mb-1 mt-4">To</p>
            <Input
              type="number"
              value={to}
              onChange={handleToChange}
              placeholder="1,000,000,000,000"
            />
            <div>
              <div className="flex justify-between items-center mt-7">
                <p className="text-[#71717A] mb-1">Selected range</p>
                <div className="bg-[#D9D9D9] px-8 py-1 text-sm rounded-full">
                  {`${from} - ${to}`}
                </div>
              </div>
              <div className="flex items-center mt-3">
                <p className="text-[#71717A] me-3">Unknown Company Size</p>

                <Checkbox
                  checked={size}
                  onChange={handleCheckboxChange}
                  sx={{
                    color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={() => navigate(-1)} className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default CompanySize;
